import React from "react";
import classNames from "classnames";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
} from "@planzone/view-models";
import { useTranslation } from "react-i18next";
import { SelectList } from "@common/selectList";
import { ColumnIcon } from "../columnIcon";
import { Props } from "./types";
import styles from "./styles.scss";

const fixedColumns = [
  "zone",
  "weather",
  "strategicScore",
  "activityMonitoring",
  "projectManagers",
  // "activityMonitoring_done",
  // "activityMonitoring_delayed",
  // "activityMonitoring_opened",
  "workload",
  // "workload_allocatedTime",
  // "workload_spentTime",
  // "workload_remainingWork",
  "budget",
  // "budget_plannedBudget",
  // "budget_realCosts",
  // "budget_acquiredValue",
];

function Form({ lang, project, formData, edit }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template: planzoneTemplate } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "project",
  );
  const { template: projectTemplate } = useRetrieveSecondaryCriteriaTemplate(
    project ? project.uuid : "",
    "project",
  );
  const template = [...planzoneTemplate, ...projectTemplate];
  const columns = [
    ...fixedColumns.map((key) => ({
      uuid: key,
      name: t(`projectDetailsConfiguration.columnNames.${key}`),
    })),
    ...template.map((criteria) => ({
      ...criteria,
      name: criteria.labels[lang as keyof typeof criteria.labels]
        ? criteria.labels[lang as keyof typeof criteria.labels]
        : criteria.name,
    })),
  ].filter(({ uuid }) => !formData.elements.find(({ key }) => key === uuid));

  return (
    <SelectList listClassName={styles.listRoot}>
      {({ select }) => ({
        input: (
          <div className={styles.input}>
            <p>{t("projectDetailsConfiguration.addColumn")}</p>
          </div>
        ),
        list: (
          <div className={styles.list}>
            {columns.map((column) => (
              <div
                key={column.uuid}
                className={styles.item}
                onClick={() =>
                  edit({
                    ...formData,
                    elements: [
                      ...formData.elements,
                      column.uuid === "budget"
                        ? {
                            type: "section",
                            label: {
                              fr: "Budget",
                              en: "Budget",
                            },
                            key: "budget",
                            elements: [
                              {
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                key: "budget_allocatedBudget",
                                elements: [],
                              },
                              {
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                key: "budget_plannedBudget",
                                elements: [],
                              },
                              {
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                key: "budget_realCosts",
                                elements: [],
                              },
                              {
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                key: "budget_acquiredValue",
                                elements: [],
                              },
                              {
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                key: "budget_realMargin",
                                elements: [],
                              },
                              {
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                key: "budget_plannedMargin",
                                elements: [],
                              },
                            ],
                          }
                        : column.uuid === "workload"
                          ? {
                              type: "section",
                              label: {
                                fr: "Travail",
                                en: "Work",
                              },
                              key: "workload",
                              elements: [
                                {
                                  type: "column",
                                  label: {
                                    fr: "",
                                    en: "",
                                  },
                                  key: "workload_allocatedTime",
                                  elements: [],
                                },
                                {
                                  type: "column",
                                  label: {
                                    fr: "",
                                    en: "",
                                  },
                                  key: "workload_spentTime",
                                  elements: [],
                                },
                                {
                                  type: "column",
                                  label: {
                                    fr: "",
                                    en: "",
                                  },
                                  key: "workload_remainingWork",
                                  elements: [],
                                },
                              ],
                            }
                          : column.uuid === "activityMonitoring"
                            ? {
                                type: "section",
                                label: {
                                  fr: "Suivi de l'activité",
                                  en: "Activity monitoring",
                                },
                                key: "activityMonitoring",
                                elements: [
                                  {
                                    type: "column",
                                    label: {
                                      fr: "",
                                      en: "",
                                    },
                                    key: "activityMonitoring_done",
                                    elements: [],
                                  },
                                  {
                                    type: "column",
                                    label: {
                                      fr: "",
                                      en: "",
                                    },
                                    key: "activityMonitoring_delayed",
                                    elements: [],
                                  },
                                  {
                                    type: "column",
                                    label: {
                                      fr: "",
                                      en: "",
                                    },
                                    key: "activityMonitoring_opened",
                                    elements: [],
                                  },
                                ],
                              }
                            : {
                                key: column.uuid,
                                type: "column",
                                label: {
                                  fr: "",
                                  en: "",
                                },
                                elements: [],
                              },
                    ],
                  })
                }
              >
                <ColumnIcon
                  criteriaKey={column.uuid}
                  className={classNames(styles.icon, {
                    [styles.timeSheetIcon]: new RegExp(
                      "activityMonitoring",
                      "i",
                    ).test(column.uuid),
                  })}
                />
                <p className={styles.name}>{column.name}</p>
              </div>
            ))}
          </div>
        ),
      })}
    </SelectList>
  );
}

export { Form };
